import store from '@/store/store'

export const privilegesService = (function () {
  "use strict";
  function validatePrivilegesOr(conditions) {
    const permissions = store.getters['user/getPrivileges'] || []
    let result = false
    if (conditions && conditions.length > 0) {
      conditions.forEach((condition) => {
        result = result || permissions.includes(condition)
      })
    }
    return result
  }

  function validatePrivilegesAnd(conditions) {
    const permissions = store.getters['user/getPrivileges'] || []
    let result = true
    if (conditions && conditions.length > 0) {
      conditions.forEach((condition) => {
        result = result && permissions.includes(condition)
      })
    }
    return !!result
  }

  function validatePrivileges(conditions) {
    let result = true;
    if (conditions.and) {
      result = validatePrivilegesAnd(conditions.and)
    }
    if (result && conditions.or) {
      result = validatePrivilegesOr(conditions.or)
    }
    return result
  }

  function getPrivileges() {
    return store.getters['user/getPrivileges'] || [];
  }

  return {
    validatePrivilegesOr,
    validatePrivilegesAnd,
    validatePrivileges,
    getPrivileges
  };
})();